/* libs/shared/src/lib/ui/generic-card/generic-card.component.scss */
.box-parent {
  border-radius: var(--radius-lg);
  box-shadow: var(--shadow-md);
  background-color: var(--background-white);
  padding: var(--space-lg);
  position: relative;
  max-width: 98%;
  left: 10px;
  transition: var(--transition-normal);
  border: 1px solid transparent;
}
.box-parent.elevated {
  box-shadow: var(--shadow-lg);
  border: 1px solid var(--background-border);
}
.box-parent .card-header {
  margin-bottom: var(--space-lg);
  padding-bottom: var(--space-md);
  border-bottom: 1px solid var(--background-border);
}
.box-parent .card-header h1,
.box-parent .card-header h2,
.box-parent .card-header h3,
.box-parent .card-header h4,
.box-parent .card-header h5,
.box-parent .card-header h6 {
  margin: 0;
  color: var(--text-primary);
  font-weight: 600;
}
.box-parent .card-content {
  color: var(--text-secondary);
  line-height: 1.6;
}
.box-parent .card-footer {
  margin-top: var(--space-lg);
  padding-top: var(--space-md);
  border-top: 1px solid var(--background-border);
  display: flex;
  justify-content: flex-end;
  gap: var(--space-sm);
}
@media (max-width: 768px) {
  .box-parent {
    max-width: 100%;
    left: 0;
    margin: var(--space-sm);
    padding: var(--space-md);
  }
}
/*# sourceMappingURL=generic-card.component.css.map */
